__turbopack_context__.v({
  "team__right__content": "page-module__ztGHiG__team__right__content",
  "team__right__teamslist": "page-module__ztGHiG__team__right__teamslist",
  "team__right__toolbar": "page-module__ztGHiG__team__right__toolbar",
});
